import React from 'react';
import Component from '../../components/Component';
import Datagrid from '../../components/Datagrid';
import Renderers from '../../helpers/Renderers';
import DbInfo from '../../dbinfo';
import c from '../../constants';
import {FormManager} from 'reactis-forms';
import {FilterInput, Select, SearchInput} from 'reactis-inputs';
import {FilterResetButton, FilterField} from 'reactis-datagrid';
import {Button, ButtonToolbar} from 'react-bootstrap';
import {AlertWindow} from 'reactis-modal';
import EventEmitter from '../../EventEmitter';
import DateRange from '../../components/Form/DateRange';
import DocumentTitle from 'react-document-title';
import {connect} from 'react-redux';
import ActiveSelect from '../../components/Form/ActiveSelect';
import {bindActionCreators} from 'redux';
import NavBar from '../../components/NavBar';
import store from 'store2';

export default class List extends Component {

	constructor(props, context) {
		super(props);

		const rendererLink = (val, row) => {
			return <a href={__URLPREFIX__ + '/user/'+row.id} onClick={(e) => this.handleOpen(row, e)}>{val}</a>;
		};

		this.columnModel = [
			{
				name: 'id',
				title: 'ID',
				field: 'id',
				width: 40,
				viewport: 'tablet',
				align: 'center'
			},
			{
				name: 'image',
				title: 'Foto',
				field: 'image',
				sortable: false,
				width: 60,
				viewport: 'tablet',
				align: 'center',
				renderer: (val) => {
					if (val) {
						return <img src={val.url} style={{height: val.height, width: val.width}}/>;
					}
				}
			},
			{
				name: 'name',
				title: 'Jméno',
				field: 'name',
				renderer: rendererLink
			},
			{
				name: 'surname',
				title: 'Příjmení',
				field: 'surname',
				renderer: rendererLink
			},
			{
				name: 'email',
				title: 'E-mail',
				field: 'email',
				viewport: 'tablet'
			},
			{
				name: 'phone',
				title: 'Telefon',
				field: 'phone',
				viewport: 'tablet'
			},
			/*{
				name: 'role',
				title: 'Role',
				field: 'role',
				viewport: 'tablet',
				renderer: Renderers.DbInfo.bind(DbInfo.Roles)
			},*/
			{
				name: 'active',
				title: 'Aktivní',
				field: 'active',
				width: 60,
				align: 'center',
				viewport: 'tablet',
				renderer: Renderers.coloredCheck
			},
			{
				name: 'edit',
				title: 'Akce',
				field: 'id',
				style: {whiteSpace: 'nowrap'},
				width: 30,
				align: 'center',
				sortable: false,
				renderer: (val, row) => {
					return (
						<a href={__URLPREFIX__ + '/user/'+val} onClick={(e) => this.handleOpen(row, e)}>
							<i className="fa fa-pencil position-left"></i><span className="vp-desktop">Upravit</span>
						</a>
					);
				}
			}
		];

		const filterSchema = {
			id: { class: FilterInput },
			name: { class: FilterInput },
			surname: { class: FilterInput },
			email: { class: FilterInput },
			phone: { class: FilterInput },
			role: {
				class: Select,
				options: DbInfo.Roles
			},
			image: {class:  Select, options: [{id: '1', title: 'Má'},{id: '0', title:'Nemá'}], placeholder: '---'},
			active: {class:  Select, options: [{id: '1', title: 'Ano'},{id: '0', title:'Ne'}], placeholder: '---'},
			fulltext: { class: SearchInput },
			edit: {
				class: FilterResetButton,
				visible: () => this.filter.isChanged(),
				onClick: () => this.filter.reset()
			}
		};
		this.filter = new FormManager(filterSchema);
		const sessionState = store.session.get('dg-user');
		// default
		let filter = {};
		// session
		if (sessionState && sessionState.filter) {
			filter = sessionState.filter;
		}
		this.defaultFilter = filter;
		this.defaultSort = sessionState && sessionState.sort ? sessionState.sort : {column: 'id', 'direction': 'asc'};

	}

	componentDidMount() {
		this.changeListener = () => {
			this.refs.datagrid.getWrappedInstance().refresh();
		};
		EventEmitter.on('user.change', this.changeListener);
	}

	componentWillUnmount() {
		EventEmitter.removeListener('user.change', this.changeListener);
	}

	handleOpen(row, e) {
		e.preventDefault();
		this.props.actions.openTabForm('user', row.title, row);
	}

	handleNewClick(e) {
		e.preventDefault();
		this.props.newTab();
	}

	render() {

		const buttons = <Button href={__URLPREFIX__ + "/user/0"} onClick={(e) => this.handleNewClick(e)}>
			<i className="fa fa-plus position-left"/>Nový uživatel
		</Button>;


		return (
			<div>
				<NavBar title="Uživatelé" buttons={[{icon: 'fa fa-refresh', onClick: () => this.refs.datagrid.getWrappedInstance().refresh()},{icon: 'fa fa-plus', onClick: () => this.props.newTab()}]} />
				<Datagrid
					ref="datagrid"
					id="user"
					api="user.getList"
					buttons={buttons}
					filters={['fulltext']}
					filter={this.filter}
					saveState={true}
					columnModel={this.columnModel}
					defaultFilter={this.defaultFilter}
					defaultSort={this.defaultSort}
				/>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/containers/User/List.js